import * as React from "react";
import {
  Create,
  ImageInput,
  ImageField,
  SimpleForm, required, NumberInput, TextInput
} from "react-admin";

export const GalleryCreateForm = () => (
  <SimpleForm>
    <TextInput source="code" validate={[required()]} label="Unique Code" />
    <ImageInput source="file" label="Related picture">
      <ImageField source="src" title="title" />
    </ImageInput>
  </SimpleForm>
);
export const GalleryCreate = () => (
  <Create>
    <GalleryCreateForm />
  </Create>
);

